import { cn } from '#client/lib/cn';
import {
  WIZARD_STEPS,
  WIZARD_STEP_LABELS,
  type WizardStep,
  stepIndex,
} from './import-wizard.logic';

/** The numbered step list across the top of the wizard. */
export function WizardStepNav({
  step,
  isDisabled,
  onSelect,
}: {
  step: WizardStep;
  /** Every step is disabled: no run yet, or the write has begun. */
  isDisabled: boolean;
  onSelect: (step: WizardStep) => void;
}) {
  const current = stepIndex(step);

  return (
    <ol className="c-steps">
      {WIZARD_STEPS.map((target, index) => (
        <li
          key={target}
          className={cn(
            'c-step',
            index === current && 'c-step--current',
            index < current && 'c-step--done',
          )}
        >
          <button
            type="button"
            className="c-step__button"
            // Never forward past where the run has got to, and never back once
            // the write has begun.
            disabled={isDisabled || index > current}
            onClick={() => onSelect(target)}
            aria-current={index === current ? 'step' : undefined}
          >
            <span className="c-step__index">{index + 1}</span>
            <span className="c-step__label">{WIZARD_STEP_LABELS[target]}</span>
          </button>
        </li>
      ))}
    </ol>
  );
}
